import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="5 Exemples d'acquittement pour alcool au volant - Défenses possibles!"
            description="Vous avez été arrêté pour alcool au volant ? Nous vous expliquons cette infraction criminelle et présentons cinq exemples concrets d’acquittement dans ce type de dossier!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour Alcool au volant">
            <p>
                Avoir les facultés affaiblies au volant d’un véhicule vient avec
                de lourdes conséquences. Certaines conséquences surviennent
                avant même d’être déclaré coupable, notamment la suspension de
                votre permis de conduire.
            </p>
            <p>
                En revanche, être intercepté par la police ne veut pas dire que
                vous serez automatiquement reconnu coupable. Il est possible
                qu’un juge vous acquitte pour l’une des raisons suivantes:
            </p>
            <ul>
                <li>Violation de vos droits,</li>
                <li>Intoxication involontaire,</li>
                <li>Analyse incorrecte, ou </li>
                <li>Délais déraisonnables. </li>
            </ul>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Conséquences d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous donne 5 exemples
                    d’acquittement pour conduite avec les facultés affaiblies!
                </strong>
            </p>
            <p>
                <strong>
                    Comment se faire acquitter de conduite avec les facultés
                    affaiblies par l’alcool ?
                </strong>
            </p>
            <p>
                Être accusé de conduite avec facultés affaiblies n’implique pas
                automatiquement une condamnation. Comme dans toute poursuite
                criminelle, l’accusé est <strong>présumé innocent</strong>{' '}
                jusqu’à preuve du contraire.
            </p>
            <p>
                C’est au procureur de la Couronne de prouver,{' '}
                <strong>hors de tout doute raisonnable,</strong> que l’accusé a
                commis l’infraction de conduite avec les facultés affaiblies.
            </p>
            <p>
                Pour obtenir une condamnation, la poursuite doit démontrer les
                éléments suivants :
            </p>
            <ul>
                <li>
                    <strong>L’identité du conducteur</strong> : Il faut prouver
                    que l’accusé conduisait ou avait le contrôle du véhicule.
                    Cette preuve peut reposer sur des témoignages, des vidéos de
                    surveillance ou des aveux.
                </li>
                <li>
                    <strong>Le contrôle du véhicule : </strong>Il est interdit
                    d’avoir la garde ou le contrôle d’un véhicule en état
                    d’ébriété, même à l’arrêt.
                </li>
            </ul>
            <p>
                Par exemple, une personne assise au volant avec les clés à
                proximité a le contrôle du véhicule. Toutefois, si l’accusé
                démontre que le véhicule était inutilisable ou qu’il n’avait pas
                l’intention de le démarrer, cela pourrait entraîner un
                acquittement.
            </p>
            <ul>
                <li>
                    <strong>L’affaiblissement des facultés :</strong> La
                    poursuite doit prouver que la capacité de conduire était
                    compromise, ou que le taux d’alcool dépassait la limite
                    légale dans les deux heures suivant la conduite. Des
                    résultats d’analyse sanguine ou des observations policières
                    peuvent appuyer cette preuve.
                </li>
            </ul>
            <p>
                Si l’un des éléments n’est pas convaincant, l’accusé ne sera pas
                reconnu coupable. C’est pourquoi il est recommandé de{' '}
                <strong>consulter un avocat dès l’arrestation</strong>. Il
                pourra évaluer les failles potentielles dans la preuve et
                préparer une défense efficace.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Acquitté de conduite avec les facultés affaiblies par l’alcool!"
                    alt=""
                />
            </p>
            <p>
                Si la poursuite n’a pas les preuves suffisantes ou si vous avez
                des moyens de défense qui soulèvent un doute raisonnable, vous
                serez acquitté.
            </p>
            <h2>
                <strong>
                    5 exemples d’acquittement pour l’infraction de conduite avec
                    facultés affaiblies par l’alcool
                </strong>
            </h2>
            <p>
                Il existe plusieurs raisons et scénarios pouvant mener à
                l’acquittement d’une personne accusée de conduite avec les
                facultés affaiblies. En voici cinq à connaître :
            </p>
            <h3>
                <strong>
                    1) Acquitté pour violation du droit de connaître les motifs
                    de l’arrestation
                </strong>
            </h3>
            <p>
                Vous serez acquitté si les policiers qui ont procédé à votre
                arrestation ne vous ont pas informé des motifs de l’arrestation{' '}
            </p>
            <h4>
                <strong>Un droit garanti par la Charte canadienne:</strong>
            </h4>
            <p>
                Lorsqu’une personne est arrêtée, la Charte canadienne garantit
                certains droits fondamentaux. L’un d’eux, prévu à{' '}
                <Link to="https://www.canlii.org/fr/ca/legis/lois/annexe-b-de-la-loi-de-1982-sur-le-canada-r-u-1982-c-11/derniere/annexe-b-de-la-loi-de-1982-sur-le-canada-r-u-1982-c-11.html#art10">
                    l’article 10a)
                </Link>
                , stipule que toute personne arrêtée a le droit d’être informée{' '}
                <strong>sans délai des raisons de son arrestation.</strong>
            </p>
            <p>
                Ce droit vise à s’assurer que l’accusé comprenne pleinement la
                nature des accusations portées contre lui afin de pouvoir réagir
                de façon éclairée, notamment en consultant un avocat.
            </p>
            <p>
                Dans le contexte d’une arrestation pour conduite avec les
                facultés affaiblies, les policiers doivent donc expliquer
                clairement et immédiatement la raison de l’arrestation. Il est
                nécessaire que cette explication soit formulée en termes simples
                et compréhensibles, sans jargon juridique ni confusion.
            </p>
            <h4>
                <strong>Les conséquences juridiques d'une violation:</strong>
            </h4>
            <p>
                Toute déclaration ou preuve obtenue durant cette période
                d’ignorance ou d’incertitude quant aux motifs de l’arrestation
                peut être déclarée inadmissible devant le tribunal.
            </p>
            <p>
                La Couronne peut se retrouver dans l’impossibilité de présenter
                des éléments de preuve essentiels et être incapable de
                satisfaire à son fardeau de preuve, ce qui peut mener à un
                verdict de non-culpabilité pour l’accusé.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Violation du droit de connaître les motifs de l’arrestation!"
                    alt=""
                />
            </p>
            <h3>
                <strong>
                    2) Acquittement en raison de la violation du droit à
                    l’assistance d’un avocat
                </strong>
            </h3>
            <p>
                Les policiers ont l’obligation de garantir le droit à
                l’assistance d’un avocat. Le non-respect de cette obligation
                peut entraîner l’acquittement de l’accusé.
            </p>
            <h4>
                <strong>Un droit protégé par la Charte canadienne:</strong>
            </h4>
            <p>
                Tout comme le droit de connaître les motifs de son arrestation,
                le droit à l’assistance d’un avocat est garanti par la Charte
                canadienne des droits et libertés, à{' '}
                <Link to="https://www.canlii.org/fr/ca/legis/lois/annexe-b-de-la-loi-de-1982-sur-le-canada-r-u-1982-c-11/derniere/annexe-b-de-la-loi-de-1982-sur-le-canada-r-u-1982-c-11.html#art10">
                    l’article 10b)
                </Link>
                .
            </p>
            <p>
                Ce droit assure que toute personne arrêtée puisse obtenir des
                conseils juridiques sans délai, ce qui est essentiel pour la
                protéger contre toute forme de pression pouvant la conduire à
                s’auto-incriminer.{' '}
                <strong>Les obligations des policiers:</strong>
            </p>
            <p>
                Dès l’arrestation, les policiers doivent informer clairement
                l’individu de son droit à consulter un avocat et lui offrir un
                accès immédiat à celui-ci. Cela peut se traduire par plusieurs
                moyens, tels que :
            </p>
            <ul>
                <li>La communication avec un avocat de garde</li>
                <li>La mise à disposition d’une liste d’avocats locaux</li>
                <li>Les informations sur l’aide juridique disponible</li>
            </ul>
            <p>
                Toute demande de l’accusé pour consulter un avocat doit être
                satisfaite <strong>sans délai excessif! </strong>Les policiers
                doivent permettre à la personne arrêtée d’utiliser un téléphone
                pour joindre son avocat.{' '}
            </p>
            <h4>
                <strong>Les conséquences d’une violation:</strong>
            </h4>
            <p>
                Une omission de mentionner le droit à l’assistance d’un avocat,
                un retard injustifié ou un refus d’accès à ce droit compromet
                sérieusement la capacité de l’accusé à assurer sa défense et
                porte atteinte à l’équité du procès.
            </p>
            <p>
                En cas de non-respect, la défense peut présenter une requête en
                exclusion des éléments de preuve obtenus durant la période de
                violation. Le juge peut alors décider d’accepter la requête et
                d’écarter ces preuves.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Requête en exclusion des éléments de preuve!"
                    alt=""
                />
            </p>
            <p>
                Selon la gravité de l’atteinte, cette exclusion peut conduire la
                Couronne à abandonner les accusations ou mener à un verdict de
                non-culpabilité en raison d’un manque de preuve suffisante.
            </p>

            <h3>
                <strong>
                    3) Acquittement fondé sur l’intoxication involontaire
                </strong>
            </h3>
            <p>
                Une personne accusée de conduite avec facultés affaiblies peut
                être acquittée si elle démontre avoir{' '}
                <strong>été intoxiquée involontairement,</strong> c’est-à-dire
                sans avoir eu conscience de son état au moment de prendre le
                volant. Cette défense repose sur l’idée que l’accusé n’avait pas
                l’intention de conduire en étant affaibli par l’alcool.
            </p>
            <p>
                L’accusé doit fournir des éléments de preuve crédibles
                permettant de croire que son intoxication était réelle et non
                délibérée. Il n’a pas à prouver son innocence au-delà de tout
                doute raisonnable, mais plutôt à rendre cette version des faits
                plus probable qu’improbable.
            </p>
            <p>
                Par exemple, une personne ayant consommé des mocktails contenant
                accidentellement de l’alcool à son insu peut invoquer cette
                défense si elle est arrêtée au volant. Le tribunal devra alors
                déterminer si l’accusé pouvait sincèrement ignorer qu’il avait
                les facultés affaiblies. Si cette version des faits paraît plus
                probable qu’improbable, l’accusé pourra être acquitté.
            </p>
            <h3>
                <strong>
                    4) Acquittement pour analyse incorrecte de l'échantillon
                    d'haleine
                </strong>
            </h3>
            <p>
                Pour qu’un conducteur soit déclaré coupable de conduite avec
                facultés affaiblies par l’alcool, il faut prouver que son
                aptitude à conduire était altérée par l’alcool, des drogues ou
                une combinaison des deux. À défaut, la preuve peut aussi
                s’appuyer sur un taux d’alcool égal ou supérieur à 80 mg par 100
                ml de sang, mesuré dans les deux heures suivant la conduite.
            </p>
            <h4>
                <strong>
                    Exigences techniques prévues par le Code criminel:
                </strong>
            </h4>
            <p>
                Le Code criminel impose des exigences précises quant à la
                collecte et à l’analyse des échantillons d’haleine. Ces normes
                visent à garantir que les résultats fournis par un éthylomètre
                homologué soient recevables en justice. La loi prévoit une
                présomption de fiabilité lorsque certains critères sont
                respectés par le technicien qualifié qui manipule l’appareil.
            </p>
            <ul>
                <li>
                    Avant chaque prélèvement, un test à blanc doit être effectué
                    pour vérifier l’absence d’alcool résiduel dans l’appareil,
                    avec un seuil maximal fixé à 10 mg d’alcool par 100 ml de
                    sang.
                </li>
                <li>
                    Ensuite, un étalonnage doit démontrer que l’éthylomètre
                    présente un écart maximal de 10% par rapport à une valeur
                    cible certifiée par un analyste.
                </li>
                <li>
                    Par ailleurs, les prélèvements doivent être réalisés avec un
                    intervalle d’au moins 15 minutes entre chaque échantillon.
                </li>
                <li>
                    Enfin, les résultats obtenus doivent être arrondis à la
                    dizaine inférieure et ne doivent pas différer de plus de 20
                    mg d’alcool par 100 ml entre eux.
                </li>
            </ul>
            <h4>
                <strong>Conséquences du non-respect des procédures:</strong>
            </h4>
            <p>
                Lorsque ces conditions ne sont pas respectées, la fiabilité des
                mesures est remise en question, générant ainsi un doute
                raisonnable sur le taux d’alcool réel du conducteur.
            </p>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Acquittement pour analyse incorrecte de l'échantillon d'haleine!"
                    alt=""
                />
            </p>
            <p>
                Ce doute peut suffire à faire échouer la preuve de la poursuite,
                entraînant alors un acquittement de l’accusé. Cette protection
                est essentielle pour garantir un procès équitable et le respect
                des droits fondamentaux.
            </p>
            <h3>
                <strong>
                    5) Acquittement en raison de la violation du droit d’être
                    jugé dans un délai raisonnable!
                </strong>
            </h3>
            <p>
                Une personne accusée de conduite avec facultés affaiblies par
                l’alcool peut voir les accusations être abandonnées si son
                procès ne se tient pas dans un délai jugé raisonnable.
            </p>
            <h4>
                <strong>Un droit protégé par la Charte canadienne:</strong>
            </h4>
            <p>
                <Link to="https://canlii.ca/t/dfbx#art11">L’article 11b)</Link>{' '}
                de la Charte garantit à toute personne accusée d’une infraction
                criminelle le droit d’être jugée dans un délai raisonnable. Ce
                droit vise à assurer une justice équitable, à protéger
                l’intégrité du processus judiciaire et à éviter que les accusés
                ne subissent des délais injustifiés.
            </p>
            <p>
                Dans l’arrêt{' '}
                <Link to="https://www.canlii.org/fr/ca/csc/doc/2016/2016csc27/2016csc27.html">
                    Jordan
                </Link>
                , la Cour suprême du Canada a clarifié ce principe en fixant des
                délais maximaux pour la tenue d’un procès :
            </p>
            <ul>
                <li>
                    18 mois lorsque l’affaire est instruite devant une cour
                    provinciale sans enquête préliminaire.
                </li>
                <li>
                    30 mois lorsque l’affaire comprend des étapes plus
                    complexes, telles qu’une enquête préliminaire ou un procès
                    devant une cour supérieure.
                </li>
            </ul>
            <p>
                Lorsque ces plafonds sont dépassés sans justification
                suffisante, le délai est présumé déraisonnable.
            </p>
            <h4>
                <strong>Les conséquences d’une violation:</strong>
            </h4>
            <p>
                Lorsque le droit d’être jugé dans un délai raisonnable n’est pas
                respecté, l’accusé ou son avocat peut présenter une requête en
                arrêt des procédures fondée sur la violation de l’article 11b).
            </p>
            <p>
                Si le tribunal conclut que ce droit a été violé sans
                justification valable, il peut ordonner l’arrêt des procédures
                judiciaires, ce qui équivaut à un acquittement.
            </p>
            <h2>
                <strong>
                    Vous avez été arrêté pour alcool au volant ? Consultez un
                    avocat spécialisé en droit criminel !
                </strong>
            </h2>
            <p>
                Si vous êtes accusé de conduite avec les facultés affaiblies par
                l’alcool, il est fortement recommandé de consulter un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé en droit criminel
                </Link>
                . Une condamnation peut engendrer des conséquences lourdes, tant
                financières que personnelles, affectant votre carrière et votre
                vie sociale.
            </p>
            <p>
                Ne négligez pas l’importance d’un avocat compétent dans ce type
                d’affaire : son intervention peut véritablement influencer
                l’issue de votre procès!
            </p>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Acquittement pour alcool au volant avec l’aide d’un avocat!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Avec notre formulaire rapide et gratuit, vous pourrez
                    facilement trouver un avocat spécialisé en droit criminel !
                </strong>
            </p>
            <p>
                <strong>
                    Suite à votre demande, nous vous mettrons rapidement en
                    contact avec un avocat près de chez vous. Ce processus ne
                    nécessite aucun engagement de votre part !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/consequences-acool-volant-quebec.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/acquittement-conduite-facultes-affaiblies-alcool.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/violation-droit-connaitre-motifs-arrestation.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/requete-exclusion-elements-preuve.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/acquittement-analyse-incorrecte-echantillon-haleine.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "exemples-acquittement-alcool-volant/acquittement-alcool-volant-avocat.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
